module.exports = __webpack_public_path__ + "static/media/icon_bed.49e8647f.svg";